import { render, staticRenderFns } from "./CustomFdkAccount.vue?vue&type=template&id=41782d36"
import script from "./CustomFdkAccount.vue?vue&type=script&lang=js"
export * from "./CustomFdkAccount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports